
export enum EPropertyTypeName {
    Apartment = "Apartment",
    Hotel = "Hotel",
    Room = "Room",
    House = "House",
    Suite = "Suite",
    Vehicle = "Vehicle",
    Experience = "Experience",
}